// custom code start
(function () {
  if (window.Tracking && window.Tracking.init && window.Tracking.init.cart) return;
  var Tracking = window.Tracking || (window.Tracking = {});
  Tracking.init = Tracking.init || {};
  Tracking.init.cart = true;

  var SESSION_KEY_VARIANT_LISTS = 'tracking:variantLists';

  var snapshot = new Map();
  var baselinePromise = null;

  function push(payload) {
    if (typeof Tracking.push === 'function') {
      Tracking.push(payload);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    }
  }

  function rememberVariantList(variantId, listId, listName) {
    if (!variantId || !listId) return;
    try {
      var map = JSON.parse(sessionStorage.getItem(SESSION_KEY_VARIANT_LISTS) || '{}');
      map[String(variantId)] = { listId: listId, listName: listName || '' };
      sessionStorage.setItem(SESSION_KEY_VARIANT_LISTS, JSON.stringify(map));
    } catch (e) { }
  }

  function getVariantList(variantId) {
    if (!variantId) return null;
    try {
      var map = JSON.parse(sessionStorage.getItem(SESSION_KEY_VARIANT_LISTS) || '{}');
      return map[String(variantId)] || null;
    } catch (e) { return null; }
  }

  function findVariantInIslands(variantId) {
    var key = String(variantId);
    var nodes = document.querySelectorAll('script[id^="dl-product-items-"]');
    for (var i = 0; i < nodes.length; i++) {
      try {
        var map = JSON.parse(nodes[i].textContent);
        if (map && map[key]) return map[key];
      } catch (e) { }
    }
    return null;
  }

  function isDrawerOpen() {
    var drawer = document.querySelector('cart-drawer');
    return !!(drawer && drawer.classList.contains('active'));
  }

  function resolveCartSource(source, context) {
    context = context || {};
    if (source === 'product-form') {
      if (context.inQuickAddModal) return 'plp_card';
      if (context.inProductInfo) return 'pdp';
      return 'plp_card';
    }
    if (source === 'cart-items' || source === 'cart-drawer-items') {
      return context.inDrawer ? 'popup_drawer' : 'cart_page';
    }
    return source || '';
  }

  function buildItemFromCartLine(line, quantity) {
    if (!line) return null;

    var unitPrice = (line.final_price || line.price || 0) / 100;
    var originalUnitPrice = (line.original_price || line.price || 0) / 100;
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'TRY';

    var item = {
      item_id: line.sku || line.handle || '',
      item_name: line.product_title || line.title || '',
      item_brand: "L'OCCITANE en Provence",
      item_variant: line.variant_title || '',
      item_category: '',
      item_category2: '',
      item_category3: '',
      price: unitPrice,
      original_price: originalUnitPrice,
      currency: currency,
      discount: Math.max(0, originalUnitPrice - unitPrice),
      quantity: quantity != null ? quantity : (line.quantity || 1),
      index: 0,
      item_list_id: '',
      item_list_name: '',
      affiliation: (window.Shopify && Shopify.shop) || location.hostname,
      sku: line.sku || '',
      item_variant_id: String(line.variant_id || line.id || ''),
      product_id: String(line.product_id || ''),
      image: line.image || '',
      url: line.url || '',
      description: line.product_title || line.title || '',
    };

    if (Array.isArray(line.options_with_values)) {
      line.options_with_values.forEach(function (option) {
        var key = (option.name || '').toLowerCase().trim();
        if (key) item[key] = option.value;
      });
    }

    if (Tracking.productCache && line.url) {
      var handleMatch = line.url.match(/\/products\/([^/?#]+)/);
      var cached = handleMatch ? Tracking.productCache[handleMatch[1]] : null;
      if (cached) {
        if (cached.item_category) item.item_category = cached.item_category;
        if (cached.item_category2) item.item_category2 = cached.item_category2;
        if (cached.item_category3) item.item_category3 = cached.item_category3;
      }
    }

    return item;
  }

  function resolveItem(variantId, cartLine, quantity) {
    var fromIsland = findVariantInIslands(variantId);
    if (fromIsland) {
      var clone = JSON.parse(JSON.stringify(fromIsland));
      clone.quantity = quantity;
      return clone;
    }
    return buildItemFromCartLine(cartLine, quantity);
  }

  function applyVariantListContext(item, variantId) {
    var ctx = getVariantList(variantId);
    if (ctx && ctx.listId) {
      item.item_list_id = ctx.listId;
      item.item_list_name = ctx.listName || '';
    }
  }

  function snapshotFromCart(items) {
    var map = new Map();
    if (!Array.isArray(items)) return map;
    items.forEach(function (line) {
      var key = String(line.variant_id || line.id);
      var entry = map.get(key) || { quantity: 0, line: line };
      entry.quantity += line.quantity || 0;
      entry.line = line;
      map.set(key, entry);
    });
    return map;
  }

  function ensureBaseline() {
    if (baselinePromise) return baselinePromise;
    baselinePromise = fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && Array.isArray(cart.items)) {
          snapshot = snapshotFromCart(cart.items);
        }
      })
      .catch(function () { });
    return baselinePromise;
  }

  function emitAddToCart(item, source, context) {
    var event = {
      event: 'add_to_cart',
      ecommerce: {
        currency: item.currency,
        value: (item.price || 0) * (item.quantity || 1),
        cart_source: resolveCartSource(source, context),
        items: [item],
      },
    };
    if (Tracking.userId) event.user_id = Tracking.userId;
    push(event);
  }

  function emitRemoveFromCart(item) {
    var event = {
      event: 'remove_from_cart',
      ecommerce: {
        currency: item.currency,
        value: (item.price || 0) * (item.quantity || 1),
        items: [item],
      },
    };
    if (Tracking.userId) event.user_id = Tracking.userId;
    push(event);
  }

  function handleProductFormAdd(payload) {
    var addedLine = payload && payload.cartData;
    if (!addedLine) return;

    var variantId = addedLine.variant_id || addedLine.id;
    var quantity = addedLine.quantity || 1;

    var fromIsland = findVariantInIslands(variantId);
    if (!fromIsland) return;

    var item = JSON.parse(JSON.stringify(fromIsland));
    item.quantity = quantity;
    item.index = 0;

    if (payload.listId) {
      item.item_list_id = payload.listId;
      item.item_list_name = payload.listName || '';
      rememberVariantList(variantId, payload.listId, payload.listName);
    } else if (item.item_list_id) {
      rememberVariantList(variantId, item.item_list_id, item.item_list_name);
    }

    emitAddToCart(item, 'product-form', {
      inProductInfo: !!payload.inProductInfo,
      inQuickAddModal: !!payload.inQuickAddModal,
    });
  }

  function handleCartQuantityChange(payload) {
    var cart = payload && payload.cartData;
    if (!cart || !Array.isArray(cart.items)) return;

    ensureBaseline().then(function () {
      var previous = snapshot;
      var current = snapshotFromCart(cart.items);
      var context = { inDrawer: isDrawerOpen() };

      var allVariantIds = {};
      previous.forEach(function (_, k) { allVariantIds[k] = true; });
      current.forEach(function (_, k) { allVariantIds[k] = true; });

      Object.keys(allVariantIds).forEach(function (variantId) {
        var prevEntry = previous.get(variantId);
        var currEntry = current.get(variantId);
        var delta = (currEntry ? currEntry.quantity : 0) - (prevEntry ? prevEntry.quantity : 0);
        if (delta === 0) return;

        var line = currEntry ? currEntry.line : (prevEntry ? prevEntry.line : null);
        var item = resolveItem(variantId, line, Math.abs(delta));
        if (!item) return;

        applyVariantListContext(item, variantId);

        if (delta > 0) {
          emitAddToCart(item, 'cart-items', context);
        } else {
          emitRemoveFromCart(item);
        }
      });

      snapshot = current;
    });
  }

  function emitDrawerViewCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return;

        var items = cart.items.map(function (line, index) {
          var variantId = line.variant_id || line.id;
          var item;
          var fromIsland = findVariantInIslands(variantId);
          if (fromIsland) {
            item = JSON.parse(JSON.stringify(fromIsland));
            item.quantity = line.quantity;
            item.index = index;
          } else {
            item = buildItemFromCartLine(line, line.quantity);
            if (item) item.index = index;
          }
          if (item) applyVariantListContext(item, variantId);
          return item;
        }).filter(Boolean);

        if (items.length === 0) return;

        var event = {
          event: 'view_cart',
          ecommerce: {
            currency: cart.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'TRY',
            value: (cart.total_price || 0) / 100,
            cart_id: (cart.token || '').split('?')[0],
            cart_source: 'popup_drawer',
            items: items,
          },
        };
        if (Tracking.userId) event.user_id = Tracking.userId;
        push(event);
      })
      .catch(function () { });
  }

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    var wasActive = drawer.classList.contains('active');
    new MutationObserver(function () {
      var isActive = drawer.classList.contains('active');
      if (isActive && !wasActive) emitDrawerViewCart();
      wasActive = isActive;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function dispatch(payload) {
    if (!payload) return;
    switch (payload.source) {
      case 'product-form':
        handleProductFormAdd(payload);
        baselinePromise = null;
        ensureBaseline();
        break;
      case 'cart-items':
      case 'cart-drawer-items':
        handleCartQuantityChange(payload);
        break;
    }
  }

  function trySubscribe() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, dispatch);
      return true;
    }
    return false;
  }

  function init() {
    ensureBaseline();
    watchDrawer();
    if (!trySubscribe()) {
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (trySubscribe() || tries > 40) clearInterval(iv);
      }, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
// custom code end
